import { isArray } from 'util'

/**
 * 操作基类
 */
export default class IOperaton {
    /**
     * 构造函数
     */
    constructor() {
        this.description = ''
    }

    /**
     * 检查可用性
     * @param {String} v
     */
    check(v) {
        return (
            v === this.description ||
            v.toUpperCase() === this.description.toUpperCase()
        )
    }

    /**
     * 异步为了兼容服务种类处理方法
     * @description 处理
     * @api
     */
    async process(...rest) {
        const response = await this._process(...rest)

        // 简单的返回包装
        if (response.type === 'FeatureCollection') {
            return response
        } else if (isArray(response)) {
            return {
                type: 'FeatureCollection',
                features: response
            }
        } else {
            throw '错误的分析结果！'
        }
    }

    /**
     * @interface
     * @param  {...any} rest
     */
    async _process(...rest) {
        throw 'please implement this methods'
    }
}
